


























import { Component, Mixins } from 'vue-property-decorator'
import { getSelectedCityId } from '@utils/index'
import { toNumber } from 'lodash'
import RecommendItem from './mixins/RecommendItem'

@Component
export default class ActivityItem extends Mixins(RecommendItem) {
  get activityPrice() {
    let num = toNumber(this.value.activitySkuPrice)
    num = isNaN(num) ? 0 : num
    return num
  }

  get activityPriceType() {
    if (this.value.payWay == 2) {
      /* 积分支付，显示积分 */
      return 'integral'
    } else if (this.value.payWay == 4) {
      /* 游乐卡支付，显示游乐卡 */
      return 'entertainment'
    } else if (this.value.payWay == 6) {
      /* 积分或游乐卡支付，显示积分 */
      return 'integral'
    }
    /* 其余均显示现金 */
    return ''
  }

  get rangeAge() {
    const minMonth = this.value.minMonth
    const maxMonth = this.value.maxMonth

    if (minMonth === null || maxMonth === null || minMonth == -2) {
      return ''
    }
    if (minMonth === -1 && maxMonth === 1200) {
      return ''
    }

    const s = Math.floor(minMonth / 12) // 最小岁
    const e = Math.floor(maxMonth / 12) // 最大岁
    let min = ''
    let max = ''
    let temp = ''
    if (minMonth <= -1) {
      min += '孕期'
    } else if (s < 1) {
      min += minMonth == 0 ? minMonth : minMonth + '月'
    } else {
      min += s + '岁'
    }
    temp += min
    if (e < 1) {
      if (maxMonth > 0) {
        max += maxMonth + '月'
      }
    } else {
      max += e + '岁'
    }
    if (min != max && max) {
      temp += '-'
      temp += max
    }
    return temp
  }

  get goDetailExposure() {
    const { activityId, activityTheme } = this.value
    return `200021||${JSON.stringify({ activeid: activityId, name: activityTheme, tabname: this.tab.tabName })}`
  }
  goDetail() {
    const { activityId, activityTheme } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200021', positionParam: { activeid: activityId, name: activityTheme, tabname: this.tab.tabName } })
  }

  get linkUrl() {
    const cityId = getSelectedCityId()
    return this.kwtarget(`//w.cekid.com/interaction-activity/detail/${this.value.activityId}/?citycode=${cityId}&isMiniProgram=false&refresh=no`)
  }
}
